/*!
 * ============================================================================
 * DDN Framework
 * Version : 2.0.0
 * Theme   : Horizon 3.4.0
 * Author  : DDN
 *
 * Core framework for all DDN custom sections.
 * Keep this file lightweight.
 * ============================================================================
 */

(function () {

    if (window.DDN) return;

    const DDN = {};

    /**
     * Execute callback for every matching section.
     */
    DDN.register = function (sectionName, callback) {

        if (!sectionName || typeof callback !== "function") {
            return;
        }

        function initialize(root = document) {

            root.querySelectorAll(
                `[data-ddn-section="${sectionName}"]`
            ).forEach(section => {

                if (section.dataset.ddnInitialized === "true") {
                    return;
                }

                section.dataset.ddnInitialized = "true";

                callback(section);

            });

        }

        if (document.readyState === "loading") {

            document.addEventListener(
                "DOMContentLoaded",
                () => initialize(document)
            );

        } else {

            initialize(document);

        }

        document.addEventListener("shopify:section:load", event => {

            initialize(event.target);

        });

    };

    /**
     * Query helper.
     */
    DDN.$ = function (selector, parent = document) {

        return parent.querySelector(selector);

    };

    /**
     * Query All helper.
     */
    DDN.$$ = function (selector, parent = document) {

        return [...parent.querySelectorAll(selector)];

    };

    /**
     * Toggle class helper.
     */
    DDN.toggle = function (element, className, condition) {

        if (!element) return;

        element.classList.toggle(className, condition);

    };

    /**
     * Safe event binding.
     */
    DDN.on = function (element, eventName, callback) {

        if (!element) return;

        element.addEventListener(eventName, callback);

    };

    /**
     * Smooth horizontal scroll helper.
     */
    DDN.scrollX = function (element, amount) {

        if (!element) return;

        element.scrollBy({

            left: amount,

            behavior: "smooth"

        });

    };

    /**
     * Debounce helper.
     */
    DDN.debounce = function (callback, delay = 150) {

        let timeout;

        return function (...args) {

            clearTimeout(timeout);

            timeout = setTimeout(() => {

                callback.apply(this, args);

            }, delay);

        };

    };

    /**
     * Framework Version
     */
    DDN.version = "2.0.0";

    window.DDN = DDN;

})();